// LADAS: spacer po mieszkaniu (widok przyjęty 23.10, plansze _ax/widoki/).
// Hero C1: znak LADAS, w literze D otwarte drzwi na przedpokój. Przewinięcie odtwarza wejście przez D
// (W1: kamera = viewBox SVG od całego znaku do wnętrza D, 2,4 s), które kończy się na kadrze przedpokoju.
// Pokoje: kadr na cały ekran, ciemny uchwyt na dole (nazwa, suma, „Pokaż meble”, „Kup ten pokój”),
// pigułka z podpowiedzią, metka mebla pod kursorem (obszary z masek renderu), uchwyt pokazujący ten
// mebel (R2), potwierdzenie po dodaniu (T1) i po skompletowaniu pokoju (U1 „Dalej”). „Pokaż meble”
// wysuwa szufladę: metki stają się numerami kart, najechanie podświetla mebel i rozwija jego kartę
// (wymiary, próbki wykończeń; próbka pod kursorem podmienia zdjęcie na zbliżenie materiału).
// „Podejdź” (mebel w akcji, 24.10): film z Blendera — kamera z kadru pokoju podchodzi do mebla i otwiera szuflady
// albo drzwiczki; „Wróć do pokoju” odtwarza to samo wstecz. Zamiast dawnej paralaksy z mapy głębi.
// Przejazdy między pokojami to filmy odtwarzane same (data-wideo), jak dotąd.
// Bez tego pliku strona zostaje nieruchomymi kadrami z numerami i listami mebli (ladas-spacer.css).
// Przełączniki do testów: ?ruch=1 wymusza tryb ruchu, ?ruch=0 go wyłącza, ?pomiar=1 licznik klatek.

// Horizon od 990 px przewija .page-wrapper, a nie okno (snippets/scripts.liquid, @theme/scroll-container).
import { getScrollTop, scrollTo as przewinStrone } from '@theme/scroll-container';

const KLATEK_NARAZ = 4;
const CZAS_WEJSCIA = 2400;
const CZAS_PRZEJSCIA = 2400;
const CZAS_POWROTU = 700;
const CZAS_DOJSCIA = 350;
const CISZA_PO = 450;
const PIGULKA_MS = 4000;
const POWROT_UCHWYTU_MS = 700;
const KLAWISZE_PRZEWIJANIA = [' ', 'PageDown', 'PageUp', 'ArrowDown', 'ArrowUp', 'Home', 'End'];

const miedzy = (v) => Math.min(1, Math.max(0, v));
const mix = (a, b, t) => a + (b - a) * t;
const gladko = (a, b, t) => { const x = miedzy((t - a) / (b - a)); return x * x * (3 - 2 * x); };
const ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);

// Próbki wykończeń: kolor z nazwy wariantu (nazwy z hurtowni Topeshop), dąb ze słojami.
const KOLORY = [
  [/biał|biel/, '#f4f3f0'], [/kaszmir/, '#d1cbc7'], [/sonoma/, '#c9a77c'], [/artisan/, '#b58a5a'],
  [/castello/, '#8b6a4b'], [/craft/, '#a8794e'], [/wotan/, '#6b4f3a'], [/antracyt|grafit/, '#4a4a4a'],
  [/czarn/, '#1f1f1f'], [/szar/, '#9a9590'], [/glina/, '#b9a089'], [/beż/, '#d8c8b2'],
];
// Napisy w JS: motyw podaje je w data-teksty (tłumaczenia ladas.spacer.*), makieta bierze polskie domyślne.
const TEKSTY = {
  mebel_jeden: '1 mebel', mebel_kilka: '{{ n }} meble', mebel_wiele: '{{ n }} mebli',
  w_koszyku: '{{ nazwa }} w koszyku', jest_w_koszyku: '✓ w koszyku', dodaj_mebel: '+ Dodaj ten mebel',
  koszyk_n: 'Koszyk ({{ n }})', caly_pokoj: 'Cały pokój, {{ ile }}', wybrane: 'Wybrane: {{ x }} z {{ y }}',
  dostawa: '+ dostawa {{ kwota }} · wysyłka 3–5 dni', zblizenie: 'zbliżenie · {{ kolor }}',
  podpowiedz_3d: 'Przeciągnij, by obejrzeć z boku · kliknij front, by go otworzyć', otworz_wszystko: 'Otwórz wszystko', zamknij_wszystko: 'Zamknij wszystko',
  blad: 'Nie udało się dodać mebli do koszyka. Spróbuj ponownie.',
};
// tło przeglądarki 3D: ściana i podłoga pokoju, z którego się podchodzi
const TLO_3D = {
  przedpokoj: ['#d6ccc0', '#c2a684'], salon: ['#c9bcae', '#b99c79'], sypialnia: ['#b8a692', '#b4997a'], lazienka: ['#bdb2a5', '#cbbfae'],
};
const SLOJE = 'repeating-linear-gradient(95deg, rgb(90 55 25 / 0.35) 0 1px, transparent 1px 4px, rgb(90 55 25 / 0.18) 4px 5px, transparent 5px 9px)';
const FAKTURA = 'repeating-linear-gradient(100deg, rgb(0 0 0 / 0.06) 0 2px, transparent 2px 5px)';
function tloProbki(nazwa) {
  const czesci = nazwa.toLowerCase().split('/').map((s) => s.trim()).filter(Boolean);
  const kolory = czesci.map((c) => (KOLORY.find(([w]) => w.test(c)) || [null, '#cfc6be'])[1]);
  const drewno = /dąb|sonoma|artisan|castello|craft|wotan/.test(nazwa.toLowerCase());
  const baza = kolory.length > 1 ? `linear-gradient(135deg, ${kolory[0]} 50%, ${kolory[1]} 50%)` : kolory[0];
  return `${drewno ? SLOJE : FAKTURA}, ${baza.startsWith('linear') ? baza : `linear-gradient(${baza}, ${baza})`}`;
}

class Film {
  /** @param {HTMLElement} el */
  constructor(el) {
    this.el = el;
    this.canvas = el.querySelector('canvas.ls-okno__klatki');
    /** @type {HTMLVideoElement | null} */
    this.wideo = el.querySelector('video');
    this.ctx = this.canvas ? this.canvas.getContext('2d', { alpha: false }) : null;
    this.n = Number(el.dataset.klatki) || 0;
    this.wzor = el.dataset.wzor || '';
    /** @type {(HTMLImageElement | undefined)[]} */
    this.klatki = new Array(this.n);
    this.gotowych = 0;
    this.zaczety = false;
    this.narysowana = -1;
    this.postep = 0;
  }

  url(i) {
    return this.wzor.replace(/-001(\.\w+)/, `-${String(i + 1).padStart(3, '0')}$1`);
  }

  /** Kolejność: pierwsza i ostatnia klatka, potem co ósma, co czwarta, co druga, reszta. */
  kolejka() {
    const k = [0, this.n - 1];
    for (const krok of [8, 4, 2, 1]) {
      for (let i = 0; i < this.n; i += krok) if (!k.includes(i)) k.push(i);
    }
    return k;
  }

  laduj() {
    if (this.wideo && !this.zaczety) {
      this.zaczety = true;
      this.wideo.preload = 'auto';
      this.wideo.load();
      return;
    }
    if (this.zaczety || !this.ctx || !this.n) return;
    this.zaczety = true;
    const kolejka = this.kolejka();
    const nastepna = () => {
      const i = kolejka.shift();
      if (i === undefined) return;
      const img = new Image();
      img.decoding = 'async';
      img.onload = () => {
        this.klatki[i] = img;
        this.gotowych += 1;
        this.narysowana = -1;
        this.rysuj(this.postep);
        nastepna();
      };
      img.onerror = nastepna;
      img.src = this.url(i);
    };
    for (let r = 0; r < KLATEK_NARAZ; r += 1) nastepna();
  }

  /** Rysuje klatkę najbliższą postępowi spośród już pobranych. */
  rysuj(p) {
    this.postep = p;
    if (!this.ctx) return;
    const cel = Math.round(p * (this.n - 1));
    let i = -1;
    for (let d = 0; d < this.n; d += 1) {
      if (this.klatki[cel - d]) { i = cel - d; break; }
      if (this.klatki[cel + d]) { i = cel + d; break; }
    }
    if (i < 0 || i === this.narysowana) return;
    const img = this.klatki[i];
    if (this.canvas.width !== img.naturalWidth) {
      this.canvas.width = img.naturalWidth;
      this.canvas.height = img.naturalHeight;
    }
    this.ctx.drawImage(img, 0, 0);
    this.narysowana = i;
  }
}

/** Hero C1 i wejście przez D (W1 „Prosto”): kamera to viewBox sceny SVG. Zdjęcie przedpokoju wypełnia
    w każdej klatce widoczną część wnętrza D, a na końcu przenika w kadr pokoju (ten sam co w bloku pokoju). */
class Wejscie {
  static START = [-14, -107.5, 504, 315];
  static KONIEC = [209.5, 30, 64, 40];

  /** @param {HTMLElement} el */
  constructor(el) {
    this.el = el;
    this.svg = el.querySelector('[data-ls-scena]');
    this.obraz = el.querySelector('[data-ls-scena-obraz]');
    this.skrzydlo = el.querySelector('[data-ls-skrzydlo]');
    this.klamka = el.querySelector('[data-ls-klamka]');
    this.p = -1;
  }

  ustawTryb(ruch) {
    // nieruchomo cały znak mieści się w ramie; w ruchu scena wypełnia ekran jak kadr
    this.svg?.setAttribute('preserveAspectRatio', ruch ? 'xMidYMid slice' : 'xMidYMid meet');
    if (!ruch) this.klatka(0, true);
  }

  klatka(p, wymus = false) {
    if (!this.svg || (!wymus && Math.abs(p - this.p) < 0.0005)) return;
    this.p = p;
    const e = ease(p);
    const vb = Wejscie.START.map((v, i) => mix(v, Wejscie.KONIEC[i], e));
    this.svg.setAttribute('viewBox', vb.map((v) => v.toFixed(3)).join(' '));
    const sk = 16;
    this.skrzydlo.setAttribute('d', `M${209 - sk},${-sk * 0.6} L209,0 V100 L${209 - sk},${100 + sk * 0.6} Z`);
    this.klamka.setAttribute('cx', String(209 - sk * 0.65));
    this.skrzydlo.parentElement.setAttribute('opacity', String(1 - gladko(0.55, 0.78, p)));
    // zdjęcie: prostokąt 1,6:1 pokrywający widoczną część wnętrza D
    const x0 = Math.max(vb[0], 209), y0 = Math.max(vb[1], -1);
    const x1 = Math.min(vb[0] + vb[2], 285), y1 = Math.min(vb[1] + vb[3], 101);
    let w = x1 - x0, h = y1 - y0;
    const cx = x0 + w / 2, cy = y0 + h / 2;
    if (w / h > 1.6) h = w / 1.6; else w = h * 1.6;
    this.obraz.setAttribute('x', (cx - w / 2).toFixed(3));
    this.obraz.setAttribute('y', (cy - h / 2).toFixed(3));
    this.obraz.setAttribute('width', w.toFixed(3));
    this.obraz.setAttribute('height', h.toFixed(3));
    this.el.style.setProperty('--ls-napisy', (1 - gladko(0, 0.18, p)).toFixed(3));
    this.el.style.setProperty('--ls-pokoj', gladko(0.9, 1, p).toFixed(3));
  }
}

/** Koszyk sklepu: które warianty już w nim są i ile sztuk (do „✓ w koszyku” i „Koszyk (n)”). */
class Koszyk {
  /** @param {HTMLElement} el */
  constructor(el) {
    this.dodaj = el.dataset.koszykDodaj || '/cart/add.js';
    this.stan = el.dataset.koszykStan || '/cart.js';
    this.adres = el.dataset.koszyk || '/cart';
    /** @type {Map<string, number>} wariant → sztuk */
    this.warianty = new Map();
    this.sztuk = 0;
    this.sluchacze = [];
  }

  zmiana(fn) {
    this.sluchacze.push(fn);
  }

  oglos() {
    for (const fn of this.sluchacze) fn();
  }

  wczytaj(cart) {
    this.warianty = new Map((cart.items || []).map((i) => [String(i.variant_id || i.id), i.quantity]));
    this.sztuk = cart.item_count ?? [...this.warianty.values()].reduce((a, b) => a + b, 0);
    this.oglos();
  }

  async odswiez() {
    try {
      const r = await fetch(this.stan, { headers: { Accept: 'application/json' } });
      if (r.ok) this.wczytaj(await r.json());
    } catch { /* bez koszyka (makieta, brak sieci) liczymy od zera */ }
  }

  ma(id) {
    return this.warianty.has(String(id));
  }

  /** @param {{id: string|number, quantity: number}[]} items */
  async dodajPozycje(items) {
    const r = await fetch(this.dodaj, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items.map((i) => ({ id: Number(i.id) || i.id, quantity: i.quantity })) }),
    });
    if (!r.ok) {
      const d = await r.json().catch(() => ({}));
      throw new Error(d.description || d.message || '');
    }
    for (const i of items) this.warianty.set(String(i.id), (this.warianty.get(String(i.id)) || 0) + i.quantity);
    this.sztuk += items.reduce((s, i) => s + i.quantity, 0);
    await this.odswiez();
    this.oglos();
    this.powiadomMotyw();
  }

  /** Licznik koszyka w nagłówku Horizona (w makiecie modułu @shopify/events nie ma). */
  async powiadomMotyw() {
    try {
      const { StandardEvents } = await import('@shopify/events');
      const e = new Event(StandardEvents.cartLinesUpdate, { bubbles: true });
      e.promise = Promise.resolve({ detail: { itemCount: this.sztuk } });
      document.dispatchEvent(e);
    } catch { /* nagłówek odświeży się przy następnej stronie */ }
  }
}

/** Pokój: metki, uchwyt (pokój / mebel / T1 / U1), pigułka, szuflada z kartami i próbkami. */
class Pokoj {
  /** @param {HTMLElement} el @param {Spacer} spacer */
  constructor(el, spacer) {
    this.el = el;
    this.spacer = spacer;
    this.koszyk = spacer.koszyk;
    this.form = el.querySelector('[data-ls-szafka]');
    this.uchwyt = el.querySelector('[data-ls-uchwyt]');
    this.szuflada = el.querySelector('[data-ls-szuflada]');
    this.pigulka = el.querySelector('[data-ls-pigulka]');
    this.otworzBtn = el.querySelector('[data-ls-otworz]');
    this.blad = el.querySelector('[data-ls-blad]');
    this.meble = [...el.querySelectorAll('[data-ls-mebel]')];
    this.karty = [...el.querySelectorAll('[data-ls-karta]')];
    this.pigulkaPokazana = false;
    this.stanBazowy = 'pokoj';
    this.mebelUchwytu = -1;
    this.powrot = 0;
    // mebel w akcji: warstwa z filmem podejścia nad kadrem pokoju
    this.blizej = el.querySelector('[data-ls-blizej]');
    this.filmMebla = this.blizej?.querySelector('video');
    this.plakat = this.blizej?.querySelector('img');
    this.przyMeblu = -1;

    for (const k of this.karty) this.kartaPrzygotuj(k);
    for (const m of this.meble) {
      const i = Number(m.dataset.lsMebel);
      m.querySelector('[data-ls-obszar]')?.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') this.najedz(i); });
      m.querySelector('[data-ls-obszar]')?.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') this.zjedz(i); });
      const metka = m.querySelector('[data-ls-metka]');
      metka?.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') this.najedz(i); });
      metka?.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') this.zjedz(i); });
      metka?.addEventListener('focus', () => this.najedz(i));
      metka?.addEventListener('blur', () => this.zjedz(i));
      metka?.addEventListener('click', () => { this.najedz(i); if (this.otwarta) this.karty[i]?.querySelector('input')?.focus({ preventScroll: true }); });
    }
    for (const k of this.karty) {
      const i = Number(k.dataset.lsKarta);
      k.addEventListener('pointerenter', () => this.podswietl(i));
      k.addEventListener('pointerleave', () => this.podswietl(-1));
      k.addEventListener('focusin', () => this.podswietl(i));
    }
    this.uchwyt?.addEventListener('pointerenter', () => clearTimeout(this.powrot));
    this.uchwyt?.addEventListener('pointerleave', () => this.zjedz(this.mebelUchwytu));
    this.otworzBtn?.addEventListener('click', () => (this.otwarta ? this.zamknij() : this.otworz()));
    el.querySelector('[data-ls-zwin]')?.addEventListener('click', () => this.zamknij());
    for (const b of el.querySelectorAll('[data-ls-dodaj-mebel]')) b.addEventListener('click', () => this.dodajMebel(this.przyMeblu >= 0 ? this.przyMeblu : this.mebelUchwytu));
    el.querySelector('[data-ls-podejdz]')?.addEventListener('click', () => this.podejdz(this.mebelUchwytu));
    for (const b of el.querySelectorAll('[data-ls-podejdz-karta]')) b.addEventListener('click', () => this.podejdz(Number(b.closest('[data-ls-karta]').dataset.lsKarta)));
    el.querySelector('[data-ls-wroc]')?.addEventListener('click', () => this.wroc());
    el.querySelector('[data-ls-reszta]')?.addEventListener('click', () => this.dodajReszte());
    this.form?.addEventListener('change', (e) => { if (e.target.matches('input[type=checkbox]')) this.przelicz(); });
    this.form?.addEventListener('submit', (e) => { e.preventDefault(); this.kupPokoj(); });
    this.form?.addEventListener('keydown', (e) => { if (e.key === 'Escape') { if (this.przyMeblu >= 0) this.wroc(); else if (this.otwarta) this.zamknij(); else this.wrocUchwyt(); } });
    // pigułka znika po pierwszym ruchu myszy (albo po 4 s)
    el.addEventListener('pointermove', () => this.schowajPigulke(), { passive: true });
    this.koszyk.zmiana(() => this.odswiezKoszyk());
    this.przelicz();
  }

  get otwarta() {
    return this.el.classList.contains('ma-szuflade');
  }

  /** Dane karty: wybrany wariant, cena, dostawa, ilość. */
  pozycja(i) {
    const k = this.karty[i];
    if (!k || !k.dataset.id) return null;
    return { i, id: k.dataset.id, cena: Number(k.dataset.cena), dostawa: Number(k.dataset.dostawa), ilosc: Number(k.dataset.ilosc) || 1, krotka: k.dataset.krotka, nazwa: k.dataset.nazwa, foto: k.dataset.foto, film: k.dataset.film, wstecz: k.dataset.wstecz, otwarty: k.dataset.otwarty, model: k.dataset.model, modelOpis: k.dataset.modelOpis };
  }

  pozycje() {
    return this.karty.map((_, i) => this.pozycja(i)).filter(Boolean);
  }

  kartaPrzygotuj(k) {
    const probki = [...k.querySelectorAll('[data-ls-probka]')];
    const foto = k.querySelector('[data-ls-foto]');
    const wyk = k.querySelector('[data-ls-wykonczenie]');
    const cena = k.querySelector('[data-ls-cena]');
    for (const p of probki) {
      p.style.backgroundImage = tloProbki(p.dataset.kolor || '');
      p.addEventListener('pointerenter', () => {
        if (!foto) return;
        foto.style.setProperty('--ls-zblizenie', `url("${p.dataset.foto || k.dataset.foto}")`);
        foto.dataset.podpis = this.spacer.t('zblizenie', { kolor: p.dataset.kolor });
        foto.classList.add('pokazuje-zblizenie');
      });
      p.addEventListener('pointerleave', () => foto?.classList.remove('pokazuje-zblizenie'));
      p.addEventListener('click', () => {
        for (const q of probki) q.setAttribute('aria-pressed', String(q === p));
        k.dataset.id = p.dataset.id;
        k.dataset.cena = p.dataset.cena;
        if (p.dataset.foto) k.dataset.foto = p.dataset.foto;
        if (wyk) wyk.textContent = p.dataset.kolor;
        if (cena) cena.textContent = this.spacer.kwota(Number(p.dataset.cena) * (Number(k.dataset.ilosc) || 1));
        this.przelicz();
        this.odswiezKoszyk();
      });
    }
  }

  /** Wejście do pokoju (postój): pigułka „Najedź na mebel…” na 4 s. */
  wejdz() {
    if (this.pigulkaPokazana || !this.pigulka) return;
    this.pigulkaPokazana = true;
    this.pigulka.classList.add('jest-widoczna');
    setTimeout(() => this.schowajPigulke(), PIGULKA_MS);
  }

  schowajPigulke() {
    if (this.pigulkaPokazana) this.pigulka?.classList.remove('jest-widoczna');
  }

  /** Mebel pod kursorem: metka z nazwą i ceną, uchwyt pokazuje ten mebel (R2); przy otwartej szufladzie podświetla kartę. */
  najedz(i) {
    if (this.przyMeblu >= 0) return;
    clearTimeout(this.powrot);
    this.schowajPigulke();
    for (const m of this.meble) m.classList.toggle('jest-wskazany', Number(m.dataset.lsMebel) === i);
    if (this.otwarta) { this.podswietl(i); return; }
    const poz = this.pozycja(i);
    if (!poz) return;
    this.mebelUchwytu = i;
    const u = this.uchwyt;
    u.querySelector('[data-ls-mebel-foto]').src = poz.foto;
    u.querySelector('[data-ls-mebel-nazwa]').textContent = poz.nazwa;
    u.querySelector('[data-ls-mebel-cena]').textContent = this.spacer.kwota(poz.cena * poz.ilosc);
    const dodaj = u.querySelector('[data-ls-dodaj-mebel]');
    const jest = this.koszyk.ma(poz.id);
    dodaj.disabled = jest;
    dodaj.textContent = this.spacer.t(jest ? 'jest_w_koszyku' : 'dodaj_mebel');
    const podejdz = u.querySelector('[data-ls-podejdz]');
    if (podejdz) podejdz.hidden = !(poz.film || poz.model);
    this.ustawStan('mebel');
  }

  zjedz(i) {
    if (this.przyMeblu >= 0) return;
    clearTimeout(this.powrot);
    this.powrot = setTimeout(() => {
      for (const m of this.meble) if (Number(m.dataset.lsMebel) === i) m.classList.remove('jest-wskazany');
      if (this.otwarta) this.podswietl(-1);
      else if (this.uchwyt?.dataset.stan === 'mebel' && !this.uchwyt.matches(':hover, :focus-within')) this.wrocUchwyt();
    }, POWROT_UCHWYTU_MS);
  }

  wrocUchwyt() {
    for (const m of this.meble) m.classList.remove('jest-wskazany');
    this.ustawStan(this.stanBazowy);
  }

  ustawStan(stan) {
    if (this.uchwyt) this.uchwyt.dataset.stan = stan;
  }

  /** Szuflada: karta i metka tego samego mebla podświetlone, reszta przygasa (F2), karta rośnie (G3). */
  podswietl(i) {
    this.el.classList.toggle('ma-wskazany', i >= 0 && this.otwarta);
    for (const k of this.karty) k.classList.toggle('jest-wskazana', Number(k.dataset.lsKarta) === i);
    for (const m of this.meble) m.classList.toggle('jest-wskazany', Number(m.dataset.lsMebel) === i);
  }

  otworz() {
    this.el.classList.add('ma-szuflade');
    this.spacer.el.classList.add('ma-szuflade');
    this.szuflada.inert = false;
    this.otworzBtn?.setAttribute('aria-expanded', 'true');
    this.schowajPigulke();
    this.wrocUchwyt();
  }

  zamknij(zFokusem = true) {
    if (!this.otwarta) return;
    this.el.classList.remove('ma-szuflade', 'ma-wskazany');
    this.spacer.el.classList.remove('ma-szuflade');
    this.szuflada.inert = this.spacer.ruch;
    this.otworzBtn?.setAttribute('aria-expanded', 'false');
    this.podswietl(-1);
    if (zFokusem) this.otworzBtn?.focus({ preventScroll: true });
  }

  /** W trybie ruchu szuflada jest nakładką; nieruchomo leży pod kadrem jako lista. */
  ustawTryb(ruch) {
    if (!ruch) this.zamknij(false);
    if (this.szuflada) this.szuflada.inert = ruch && !this.otwarta;
  }

  wybrane() {
    return this.pozycje().filter((p) => this.karty[p.i].querySelector('input[type=checkbox]')?.checked);
  }

  przelicz() {
    const wszystkie = this.pozycje();
    const wybrane = this.wybrane();
    const suma = wybrane.reduce((s, p) => s + p.cena * p.ilosc, 0);
    const dostawa = wybrane.reduce((s, p) => s + p.dostawa * p.ilosc, 0);
    const sztuk = (lista) => lista.reduce((s, p) => s + p.ilosc, 0);
    const opis = this.el.querySelector('[data-ls-wybrane]');
    if (opis) opis.textContent = wybrane.length === wszystkie.length ? this.spacer.t('caly_pokoj', { ile: this.spacer.meble(sztuk(wszystkie)) }) : this.spacer.t('wybrane', { x: sztuk(wybrane), y: sztuk(wszystkie) });
    const s = this.el.querySelector('[data-ls-suma]');
    if (s) s.textContent = this.spacer.kwota(suma);
    const d = this.el.querySelector('[data-ls-dostawa]');
    if (d) d.textContent = this.spacer.t('dostawa', { kwota: this.spacer.kwota(dostawa) });
    for (const b of this.el.querySelectorAll('[data-ls-kup]')) b.disabled = wybrane.length === 0;
  }

  /** Po każdej zmianie koszyka: „✓ w koszyku” na meblach i kartach, licznik, stan bazowy uchwytu (T1 / U1). */
  odswiezKoszyk() {
    const poz = this.pozycje();
    const w = poz.filter((p) => this.koszyk.ma(p.id));
    for (const p of poz) {
      const jest = this.koszyk.ma(p.id);
      this.meble.find((m) => Number(m.dataset.lsMebel) === p.i)?.classList.toggle('jest-w-koszyku', jest);
      this.karty[p.i].classList.toggle('jest-w-koszyku', jest);
    }
    for (const a of this.el.querySelectorAll('[data-ls-ile-w-koszyku]')) a.textContent = this.spacer.t('koszyk_n', { n: this.koszyk.sztuk });
    const reszta = poz.filter((p) => !this.koszyk.ma(p.id));
    const sztuk = (lista) => lista.reduce((s, p) => s + p.ilosc, 0);
    if (poz.length && !reszta.length) {
      this.el.querySelector('[data-ls-pelny-ile]').textContent = `${this.spacer.meble(sztuk(poz))} · `;
      this.el.querySelector('[data-ls-pelny-suma]').textContent = this.spacer.kwota(poz.reduce((s, p) => s + p.cena * p.ilosc, 0));
      this.stanBazowy = 'pelny';
    } else if (w.length) {
      this.el.querySelector('[data-ls-reszta-ile]').textContent = `${this.el.dataset.reszta}: ${this.spacer.meble(sztuk(reszta))} · `;
      this.el.querySelector('[data-ls-reszta-suma]').textContent = this.spacer.kwota(reszta.reduce((s, p) => s + p.cena * p.ilosc, 0));
      this.stanBazowy = 'dodany';
    } else {
      this.stanBazowy = 'pokoj';
    }
    if (this.uchwyt && this.uchwyt.dataset.stan !== 'mebel') this.ustawStan(this.stanBazowy);
  }

  async dodaj(pozycje, potwierdzenie) {
    if (!pozycje.length) return;
    this.blad.hidden = true;
    this.uchwyt.classList.add('dodaje');
    try {
      await this.koszyk.dodajPozycje(pozycje.map((p) => ({ id: p.id, quantity: p.ilosc })));
      if (potwierdzenie) this.el.querySelector('[data-ls-dodany-nazwa]').textContent = potwierdzenie;
      this.zamknij(false);
      if (this.przyMeblu >= 0) { this.ustawBlisko(this.przyMeblu); return; }
      this.wrocUchwyt();
      this.uchwyt.querySelector('[data-ls-dalej], [data-ls-reszta]')?.focus({ preventScroll: true });
    } catch (e) {
      this.blad.textContent = e.message || this.spacer.t('blad');
      this.blad.hidden = false;
    } finally {
      this.uchwyt.classList.remove('dodaje');
    }
  }

  dodajMebel(i) {
    const p = this.pozycja(i);
    if (p && !this.koszyk.ma(p.id)) this.dodaj([p], this.spacer.t('w_koszyku', { nazwa: p.krotka }));
  }

  dodajReszte() {
    this.dodaj(this.pozycje().filter((p) => !this.koszyk.ma(p.id)));
  }

  /** Mebel w akcji: kadr pokoju przenika w pierwszą klatkę filmu, kamera podchodzi i fronty się otwierają;
      zostaje otwarty mebel z uchwytem „przy meblu”. Bez ruchu (telefon, ograniczony ruch) od razu stopklatka otwartego mebla. */
  podejdz(i) {
    const poz = this.pozycja(i);
    if (!poz || !(poz.film || poz.model) || !this.blizej) return;
    clearTimeout(this.powrot);
    this.zamknij(false);
    this.schowajPigulke();
    this.przyMeblu = i;
    this.spacer.przyMeblu = this;
    this.el.classList.add('jest-przy-meblu');
    if (poz.otwarty) this.plakat.src = poz.otwarty;
    this.ustawBlisko(i);
    this.blizej.hidden = false;
    // mebel z modelem, bez filmu (render podejścia jeszcze nie gotowy): kadr pokoju przenika od razu w 3D
    if (!poz.film) { this.blizej.classList.remove('pokazuje-plakat'); this.blizej.classList.add('jest-widoczna'); this.uchwyt.querySelector('[data-ls-wroc]')?.focus({ preventScroll: true }); this.start3d(poz); return; }
    const v = this.filmMebla;
    if (!this.spacer.ruch || !v) { this.blizej.classList.add('pokazuje-plakat', 'jest-widoczna'); this.uchwyt.querySelector('[data-ls-wroc]')?.focus({ preventScroll: true }); this.start3d(poz); return; }
    this.blizej.classList.remove('pokazuje-plakat');
    v.preload = 'auto';
    if (v.getAttribute('src') !== poz.film) { v.src = poz.film; v.load(); }
    v.currentTime = 0;
    this.uchwyt.classList.add('czeka');
    let ruszyl = false;
    const start = () => { if (ruszyl || this.przyMeblu !== i) return; ruszyl = true; this.blizej.classList.add('jest-widoczna'); v.play().catch(() => this.koniecFilmu()); };
    v.onended = () => this.koniecFilmu();
    if (v.readyState >= 2) start(); else v.addEventListener('loadeddata', start, { once: true });
    // film się nie wczytuje (sieć, format): po 2,5 s stopklatka otwartego mebla
    setTimeout(() => { if (!ruszyl && this.przyMeblu === i) { ruszyl = true; this.blizej.classList.add('jest-widoczna'); this.koniecFilmu(); } }, 2500);
  }

  koniecFilmu() {
    this.uchwyt.classList.remove('czeka');
    if (this.przyMeblu < 0) return;
    this.blizej.classList.add('pokazuje-plakat');
    this.uchwyt.querySelector('[data-ls-wroc]')?.focus({ preventScroll: true });
    this.start3d(this.pozycja(this.przyMeblu));
  }

  /** Model 3D mebla z tej samej kamery co koniec filmu: obrót, przybliżenie, otwieranie frontów kliknięciem.
      Przenika nad stopklatką dopiero, gdy jest gotowy; bez modelu albo przy błędzie zostaje stopklatka. */
  async start3d(poz) {
    if (!poz.model || !poz.modelOpis || this.m3d) return;
    const i = this.przyMeblu;
    const box = document.createElement('div');
    box.className = 'ls-blizej__3d';
    this.blizej.append(box);
    const pokoj = this.el.id.replace('pokoj-', '');
    const [sciana, podloga] = TLO_3D[pokoj] || [];
    try {
      const { Mebel3D } = await import(new URL('./ladas-mebel-3d.js', import.meta.url).href);
      if (this.przyMeblu !== i) { box.remove(); return; }
      this.m3d = new Mebel3D(box, { glb: poz.model, opis: poz.modelOpis, sciana, podloga });
      await this.m3d.gotowy;
      if (this.przyMeblu !== i) { this.zamknij3d(); return; }
      box.classList.add('jest-gotowy');
      const pod = this.el.querySelector('[data-ls-podpowiedz-3d]');
      if (pod) {
        pod.textContent = this.spacer.t('podpowiedz_3d');
        pod.classList.add('jest-widoczna');
        const schowaj = () => pod.classList.remove('jest-widoczna');
        setTimeout(schowaj, 5000);
        box.addEventListener('pointerdown', schowaj, { once: true });
      }
      // „Otwórz/Zamknij wszystko” tylko przy meblu z frontami (półki MOBI ich nie mają)
      const wsz = this.uchwyt.querySelector('[data-ls-wszystko-3d]');
      if (wsz && this.m3d.ruchy.length) {
        wsz.hidden = false;
        let otwarte = true;
        wsz.textContent = this.spacer.t('zamknij_wszystko');
        wsz.onclick = () => { otwarte = !otwarte; this.m3d?.otworzWszystko(otwarte); wsz.textContent = this.spacer.t(otwarte ? 'zamknij_wszystko' : 'otworz_wszystko'); };
        box.addEventListener('ladas:front', () => { otwarte = this.m3d.ruchy.some((ru) => ru.cel === 1); wsz.textContent = this.spacer.t(otwarte ? 'zamknij_wszystko' : 'otworz_wszystko'); });
      }
    } catch (e) {
      console.warn('[ladas] model 3D niedostępny:', e);
      this.zamknij3d();
    }
  }

  zamknij3d() {
    this.m3d?.zniszcz();
    this.m3d = null;
    this.blizej.querySelector('.ls-blizej__3d')?.remove();
    this.el.querySelector('[data-ls-podpowiedz-3d]')?.classList.remove('jest-widoczna');
    const wsz = this.uchwyt.querySelector('[data-ls-wszystko-3d]');
    if (wsz) wsz.hidden = true;
  }

  /** Uchwyt przy meblu: zdjęcie, nazwa, cena, „+ Dodaj ten mebel”, „← Wróć do pokoju”. */
  ustawBlisko(i) {
    const poz = this.pozycja(i);
    const u = this.uchwyt;
    u.querySelector('[data-ls-blisko-foto]').src = poz.foto;
    u.querySelector('[data-ls-blisko-nazwa]').textContent = poz.nazwa;
    u.querySelector('[data-ls-blisko-cena]').textContent = this.spacer.kwota(poz.cena * poz.ilosc);
    const dodaj = u.querySelector('.ls-uchwyt__stan--blisko [data-ls-dodaj-mebel]');
    const jest = this.koszyk.ma(poz.id);
    dodaj.disabled = jest;
    dodaj.textContent = this.spacer.t(jest ? 'jest_w_koszyku' : 'dodaj_mebel');
    this.ustawStan('blisko');
  }

  /** Powrót do pokoju: fronty się zamykają, kamera cofa się do kadru (film wstecz), warstwa gaśnie. */
  async wroc() {
    if (this.przyMeblu < 0) return;
    const poz = this.pozycja(this.przyMeblu);
    // z 3D: kamera wraca do ujęcia końca filmu i fronty się otwierają, potem model gaśnie nad stopklatką
    if (this.m3d) {
      this.uchwyt.classList.add('czeka');
      await Promise.race([this.m3d.wrocDoStartu(500), new Promise((ok) => setTimeout(ok, 1500))]);
      const box = this.blizej.querySelector('.ls-blizej__3d');
      box?.classList.remove('jest-gotowy');
      await new Promise((ok) => setTimeout(ok, 300));
      this.zamknij3d();
    }
    const zakoncz = () => {
      this.blizej.classList.remove('jest-widoczna', 'pokazuje-plakat');
      this.el.classList.remove('jest-przy-meblu');
      setTimeout(() => { if (this.przyMeblu < 0) this.blizej.hidden = true; }, 350);
      this.przyMeblu = -1;
      this.spacer.przyMeblu = null;
      this.uchwyt.classList.remove('czeka');
      this.wrocUchwyt();
    };
    const v = this.filmMebla;
    if (!this.spacer.ruch || !v || !poz.wstecz) { zakoncz(); return; }
    // stopklatka otwartego mebla zostaje, dopóki film wstecz nie ma pierwszej klatki (bez mignięcia czernią)
    this.uchwyt.classList.add('czeka');
    let ruszyl = false;
    v.onended = zakoncz;
    v.addEventListener('loadeddata', () => { if (ruszyl) return; ruszyl = true; this.blizej.classList.remove('pokazuje-plakat'); v.play().catch(zakoncz); }, { once: true });
    v.src = poz.wstecz; v.load();
    setTimeout(() => { if (!ruszyl) { ruszyl = true; zakoncz(); } }, 2500);
  }

  kupPokoj() {
    const wybrane = this.wybrane().filter((p) => !this.koszyk.ma(p.id));
    if (!wybrane.length) { this.wrocUchwyt(); return; }
    this.dodaj(wybrane, this.spacer.t('w_koszyku', { nazwa: wybrane.length === 1 ? wybrane[0].krotka : this.spacer.meble(wybrane.reduce((s, p) => s + p.ilosc, 0)) }));
  }
}

class Spacer {
  /** @param {HTMLElement} el */
  constructor(el) {
    this.el = el;
    this.teksty = { ...TEKSTY, ...JSON.parse(el.dataset.teksty || '{}') };
    // grupowanie tysięcy jak w cenach motywu (1 363,97 zł; polski Intl domyślnie nie grupuje czterech cyfr)
    this.format = new Intl.NumberFormat(el.dataset.jezyk || 'pl', { style: 'currency', currency: el.dataset.waluta || 'PLN', useGrouping: 'always' });
    this.koszyk = new Koszyk(el);
    this.filmy = [...el.querySelectorAll('[data-ls-film]')].map((f) => new Film(f));
    const prog = el.querySelector('[data-ls-wejscie]');
    this.wejscie = prog ? new Wejscie(prog) : null;
    this.bloki = [...el.querySelectorAll('[data-ls-film], [data-ls-pokoj]')];
    for (const b of this.bloki) b.classList.add('ls-blok');
    this.pokoje = [...el.querySelectorAll('[data-ls-pokoj]')].map((p) => new Pokoj(p, this));
    this.glowka = el.querySelector('[data-ls-glowka]');
    // linki do pokoi także spoza spaceru (lista „Całe mieszkanie” niżej na stronie)
    this.linkiPlanu = [...document.querySelectorAll('a[data-ls-plan-link]')];
    this.ruch = false;
    const q = new URLSearchParams(window.location.search);
    this.wymus = q.get('ruch');
    this.pomiar = q.get('pomiar') === '1' ? this.licznik() : null;
    this.mqRuch = window.matchMedia('(prefers-reduced-motion: no-preference)');
    this.mqSzer = window.matchMedia('(min-width: 990px)');
    const tryb = () => this.ustawTryb();
    this.mqRuch.addEventListener('change', tryb);
    this.mqSzer.addEventListener('change', tryb);

    let czeka = false;
    const klatka = () => { czeka = false; this.przewin(); };
    const zglos = () => { if (!czeka) { czeka = true; requestAnimationFrame(klatka); } };
    // przechwytywanie na document łapie przewijanie i okna, i .page-wrapper
    document.addEventListener('scroll', zglos, { passive: true, capture: true });
    window.addEventListener('resize', zglos);
    // w trakcie odtwarzania i chwilę po nim przewijanie użytkownika nie przesuwa strony
    // (rozpęd gładzika odpaliłby od razu następne przejście)
    this.gra = false;
    this.pominieto = false;
    this.cisza = 0;
    this.ostatnieY = getScrollTop();
    // przy meblu (film podejścia, otwarty mebel) strona też stoi: wraca się przyciskiem albo Escape
    this.przyMeblu = null;
    const wstrzymaj = (e) => { if (this.gra || this.przyMeblu || performance.now() < this.cisza) e.preventDefault(); };
    window.addEventListener('wheel', wstrzymaj, { passive: false });
    window.addEventListener('touchmove', wstrzymaj, { passive: false });
    window.addEventListener('keydown', (e) => { if (KLAWISZE_PRZEWIJANIA.includes(e.key) && !e.target.closest?.('input, textarea')) wstrzymaj(e); });
    this.ustawTryb();

    // „Wejdź przez drzwi” w trybie ruchu tylko trąca stronę: wejście przez D odtwarza się samo
    el.querySelector('[data-ls-wejdz]')?.addEventListener('click', (e) => {
      if (!this.ruch) { this.idzDo(e); return; }
      e.preventDefault();
      if (!this.gra) przewinStrone({ top: this.el.getBoundingClientRect().top + getScrollTop() + 24, behavior: 'instant' });
    });
    el.querySelector('[data-ls-pomin]')?.addEventListener('click', () => { if (this.gra) this.pominieto = true; });
    for (const a of this.linkiPlanu) a.addEventListener('click', (e) => this.idzDo(e));
    this.koszyk.zmiana(() => {
      for (const a of document.querySelectorAll('[data-ls-koszyk-licznik]')) a.textContent = this.t('koszyk_n', { n: this.koszyk.sztuk });
    });
    this.koszyk.odswiez();
  }

  kwota(grosze) {
    return this.format.format(grosze / 100);
  }

  t(klucz, zmienne = {}) {
    return (this.teksty[klucz] || '').replace(/\{\{\s*(\w+)\s*\}\}/g, (_, k) => String(zmienne[k] ?? ''));
  }

  /** „1 mebel”, „4 meble”, „5 mebli” (w angielskim kilka = wiele) */
  meble(n) {
    const o = n % 10, s = n % 100;
    if (n === 1) return this.t('mebel_jeden', { n });
    if (o >= 2 && o <= 4 && (s < 12 || s > 14)) return this.t('mebel_kilka', { n });
    return this.t('mebel_wiele', { n });
  }

  ustawTryb() {
    const oszczedzanie = navigator.connection && navigator.connection.saveData;
    let ruch = this.mqRuch.matches && this.mqSzer.matches && !oszczedzanie;
    if (this.wymus === '1') ruch = true;
    if (this.wymus === '0') ruch = false;
    this.ruch = ruch;
    this.el.classList.toggle('ls--ruch', ruch);
    this.wejscie?.ustawTryb(ruch);
    for (const p of this.pokoje) p.ustawTryb(ruch);
    this.przewin();
  }

  /** Przelicza pozycję przewijania na postęp wejścia, przejazdów i widoczność pokoi. */
  przewin() {
    if (!this.ruch) return;
    const vh = window.innerHeight;
    // blok jest widoczny dopiero po przypięciu; pierwszy zawsze. Droga bloku kończy się tam,
    // gdzie przypina się następny (dwa ekrany przed jego końcem), ostatniego — ekran przed końcem.
    this.bloki.forEach((b, i) => b.classList.toggle('jest-przypiety', i === 0 || b.getBoundingClientRect().top <= 0.5));
    const droga = (el, r) => r.height - vh * (el === this.bloki[this.bloki.length - 1] ? 1 : 2);
    let postepWejscia = 0;
    for (const f of this.filmy) {
      const r = f.el.getBoundingClientRect();
      if (r.top < vh * 2.5 && r.bottom > -vh) f.laduj();
      if (r.bottom < 0 || r.top > vh) { if (f.el === this.wejscie?.el && r.bottom < 0) postepWejscia = 1; continue; }
      const p = miedzy(-r.top / droga(f.el, r));
      f.rysuj(p);
      f.el.style.setProperty('--ls-p', p.toFixed(4));
      if (f.el === this.wejscie?.el) { this.wejscie.klatka(p); postepWejscia = p; }
    }
    let biezacy = null;
    for (const pk of this.pokoje) {
      const pokoj = pk.el;
      const r = pokoj.getBoundingClientRect();
      const p = -r.top / droga(pokoj, r);
      // uchwyt i metki wchodzą na początku postoju i gasną tuż przed wejściem w następny przejazd
      // (ostatni pokój nie gaśnie: po postoju odjeżdża razem ze stroną)
      const ostatni = pokoj === this.bloki[this.bloki.length - 1];
      const koniec = ostatni ? 1 : Math.max(0, (1 - p) / 0.06);
      const widok = p < 0 ? 0 : Math.min(1, p / 0.06, koniec);
      pokoj.style.setProperty('--ls-widok', widok.toFixed(3));
      pokoj.classList.toggle('jest-w-drodze', widok < 0.3);
      if (widok > 0.9) pk.wejdz();
      if (p > -0.2 && (p < 1 || ostatni)) biezacy = pokoj;
      if (p < -0.1 || p > (ostatni ? 1.6 : 1.02)) pk.zamknij(false);
    }
    const s = this.el.getBoundingClientRect();
    this.glowka?.classList.toggle('jest-widoczna', postepWejscia > 0.97 && s.bottom > vh * 0.9);
    for (const a of this.linkiPlanu) {
      const mojPokoj = biezacy && a.getAttribute('href') === `#${biezacy.id}`;
      if (mojPokoj) a.setAttribute('aria-current', 'true');
      else a.removeAttribute('aria-current');
    }
    if (this.pomiar) this.pomiar();
    this.odtworzWejscie();
  }

  /** Prowadzi stronę do pozycji y w zadanym czasie, równym krokiem (tempo nadają same klatki).
      `potem` dostaje stronę po dojściu i może poprowadzić ją dalej bez oddawania przewijania. */
  graj(y, ms, potem) {
    const start = getScrollTop();
    const t0 = performance.now();
    this.gra = true;
    this.el.classList.add('ls--gra');
    const krok = (teraz) => {
      const k = this.pominieto ? 1 : Math.min(1, (teraz - t0) / ms);
      przewinStrone({ top: start + (y - start) * k, behavior: 'instant' });
      if (k < 1) { requestAnimationFrame(krok); return; }
      if (potem) { potem(); return; }
      this.pominieto = false;
      this.gra = false;
      this.el.classList.remove('ls--gra');
      this.cisza = performance.now() + CISZA_PO;
      this.ostatnieY = getScrollTop();
    };
    requestAnimationFrame(krok);
  }

  /** Strona stanęła w środku wejścia albo przejazdu: odtwarza je do końca w kierunku przewijania. */
  odtworzWejscie() {
    const y = getScrollTop();
    const wDol = y >= this.ostatnieY;
    this.ostatnieY = y;
    if (!this.ruch || this.gra) return;
    const vh = window.innerHeight;
    for (const f of this.filmy) {
      const r = f.el.getBoundingClientRect();
      const droga = r.height - vh * 2;
      const p = -r.top / droga;
      if (p <= 0.003 || p >= 0.997) continue;
      const nr = this.bloki.indexOf(f.el);
      const czas = f.el === this.wejscie?.el ? CZAS_WEJSCIA : CZAS_PRZEJSCIA;
      const ostatni = this.bloki[this.bloki.length - 1];
      const jestFilmem = (blok) => blok.hasAttribute('data-ls-film');
      const postoj = (blok, gdzie) => blok.getBoundingClientRect().top + y + (blok.offsetHeight - vh * (blok === ostatni ? 1 : 2)) * gdzie;
      const nastepny = this.bloki[nr + 1];
      // po wejściu: postój w pokoju albo sam początek następnego filmu (ten ruszy od razu)
      const dalej = nastepny ? postoj(nastepny, jestFilmem(nastepny) ? 0.01 : 0.12) : r.top + y + droga;
      if (wDol && f.wideo) {
        this.grajFilm(f, r.top + y + droga, dalej);
      } else if (wDol) {
        this.graj(dalej, Math.max(300, czas * (1 - p)));
      } else {
        const poprzedni = this.bloki[nr - 1];
        const wstecz = poprzedni ? postoj(poprzedni, jestFilmem(poprzedni) ? 0.99 : 0.5) : 0;
        this.graj(wstecz, f.wideo ? CZAS_POWROTU : Math.max(300, czas * p));
      }
      return;
    }
  }

  /** Odtwarza przejazd: film leci od początku w swoim tempie, strona jedzie pod nim do końca bloku
      (tam przypina się kadr pokoju równy ostatniej klatce) i dochodzi do postoju. Gdy film nie jest
      jeszcze pobrany, blok przenika między kadrami. */
  grajFilm(f, koniec, dalej) {
    const v = f.wideo;
    const dojscie = () => this.graj(dalej, CZAS_DOJSCIA);
    if (!v || v.readyState < 3 || !Number.isFinite(v.duration)) {
      this.graj(koniec, 900, dojscie);
      return;
    }
    const zdejmij = () => {
      this.el.classList.remove('ls--film');
      f.el.classList.remove('gra-wideo');
      v.pause();
    };
    v.currentTime = 0;
    f.el.classList.add('gra-wideo');
    this.el.classList.add('ls--film');
    v.play().catch(() => {});
    this.graj(koniec, v.duration * 1000, () => {
      // kadr pokoju przykrył film: zdjęcie klasy niczego nie odsłania
      requestAnimationFrame(() => { zdejmij(); dojscie(); });
    });
  }

  /** W trybie ruchu cel linku to początek postoju w pokoju. Do sąsiedniego następnego pokoju
      („Idź do sypialni →”) jedzie przez jego przejazd: strona staje na początku filmu, a ten rusza sam. */
  idzDo(e) {
    const href = e.currentTarget.getAttribute('href') || '';
    if (!href.startsWith('#')) return;
    const cel = this.el.querySelector(href);
    if (!cel) return;
    e.preventDefault();
    const y0 = getScrollTop();
    const nr = this.bloki.indexOf(cel);
    const przed = this.bloki[nr - 1];
    const vh = window.innerHeight;
    if (this.ruch && przed && przed.hasAttribute('data-ls-film') && przed !== this.wejscie?.el) {
      const r = przed.getBoundingClientRect();
      // jesteśmy w pokoju tuż przed tym przejazdem: wejdź w film, odtworzenie zrobi resztę
      if (r.top > 0 && r.top < vh * 3) {
        const start = r.top + y0 + (r.height - vh * 2) * 0.01;
        this.graj(start, 450, () => {
          this.gra = false;
          this.el.classList.remove('ls--gra');
          this.ostatnieY = start - 1;
          this.odtworzWejscie();
        });
        history.replaceState(null, '', href);
        return;
      }
    }
    const ekranow = cel === this.bloki[this.bloki.length - 1] ? 1 : 2;
    const dodatek = this.ruch ? (cel.offsetHeight - vh * ekranow) * 0.12 : 0;
    const y = cel.getBoundingClientRect().top + y0 + dodatek;
    if (this.ruch) {
      const droga = Math.abs(y - y0) / vh;
      this.graj(y, Math.min(3000, Math.max(900, droga * 1200)));
    } else {
      przewinStrone({ top: y, behavior: this.mqRuch.matches ? 'smooth' : 'instant' });
    }
    history.replaceState(null, '', href);
  }

  /** Licznik do prototypu: klatki na sekundę podczas przewijania. */
  licznik() {
    const pole = document.createElement('output');
    pole.style.cssText = 'position:fixed;left:8px;bottom:8px;z-index:99;padding:6px 10px;background:#2a2522;color:#f2f0ed;font:12px/1.4 ui-monospace,monospace;white-space:pre';
    document.body.append(pole);
    let ostatnia = performance.now();
    let najgorsza = 0;
    const czasy = [];
    return () => {
      const t = performance.now();
      const dt = t - ostatnia;
      ostatnia = t;
      if (dt < 250) {
        czasy.push(dt);
        if (czasy.length > 90) czasy.shift();
        najgorsza = Math.max(najgorsza, dt);
      }
      const srednia = czasy.reduce((a, b) => a + b, 0) / (czasy.length || 1);
      pole.textContent = `klatki przewijania: ${(1000 / srednia).toFixed(0)}/s · najdłuższa ${najgorsza.toFixed(0)} ms`;
    };
  }
}

for (const el of document.querySelectorAll('[data-ladas-spacer]')) {
  if (!el.dataset.lsGotowy) {
    el.dataset.lsGotowy = '1';
    new Spacer(el);
  }
}
